import http from './index'

/**
 * @desc gets the telco of a given phone number
 *
 * @param {*} number
 * @returns
 * {
 *   "responsecode": "00",
 *   "product": "airtel",
 *   "mobilenumber": "2349023016381",
 *   "telco": "airtel"
 * }
 */
const getTelco = async (number) => {
    return await http.get('/get/telco/' + number)
}

/**
 * @desc gets all telco categories
 *
 * @returns
 *  {
        "responsecode": "00",
        "availabletelco": [
            {
                "product": "MTN"
            },
            {
                "product": "GLO"
            },
            {
                "product": "AIRTEL"
            },
            {
                "product": "9MOBILE"
            }
        ]
 *   }
 */
const getTelcos = async () => {
    return await http.get('/get/airtime-categories')
}
/**
 * @desc gets all data categories
 *
 * @returns
 */
const getDataCategories = async () => {
    return await http.get('/get/data-categories')
}

const getDataServices = async (id) => {
    return await http.get('/get/data-service-categories/' + id)
}

/**
 * @desc initialize airtime buy
 *
 * @param {Object} data
 * @returns details of transaction for giving deposit type
 */
const buyAirtime = async (data) => {
    return await http.post('/airtime/initialise', data)
}

/**
 * @desc initialize data buy
 *
 * @param {Object} data
 * @returns details of transaction for giving deposit type
 */
const buyData = async (data) => {
    return await http.post('/data/initialise', data)
}

export { getTelco, getTelcos, buyAirtime, buyData, getDataCategories, getDataServices }
